import SubCategoryManagement from './sub-category-management';

export default SubCategoryManagement;
